import { useMemo } from 'react'
import { RELATIONSHIPS } from 'Data/constants.js'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    return RELATIONSHIPS
  }, [data])
}
